import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { C3Service, ModelService, Color3, ug } from '@usimweb/ceetron';
import { AuthHandler } from '@usimweb/core-auth';
import { ApiService } from '@usimweb/core/services';
import { PointSelectionService } from '../../../../core/services/point-selection/point-selection.service';
import { ColorTable } from '@usimweb/core/models';
import { take } from 'rxjs';
import { BoundingBoxService } from '@usimweb/core/services';

enum BoundaryCondition {
  empty = '-',
  wall = 'WALL',
  inlet = 'INLET',
  outlet = 'OUTLET',
}

interface RGB {
  r: number;
  g: number;
  b: number;
}

interface BoundaryConType {
  index: number;
  boundary_condition: BoundaryCondition;
  line_color: RGB;
  data: any;
}

@Component({
    selector: 'app-boundary-conditions',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './boundary-conditions.component.html',
    styleUrls: ['./boundary-conditions.component.scss'],
    standalone: false
})
export class BoundaryConditionsComponent implements OnInit {
  public curveColumnsTable: string[] = ['index', 'boundary_condition', 'line_color', 'delete'];
  public dataTableSource!: MatTableDataSource<BoundaryConType>;

  public activeIndex = 0;

  public viewer = 1;

  public loadViewer = false;

  public key = 'key';
  public value = 'value';
  public values = [
    { key: 'wall', value: 'Wall' },
    { key: 'inlet', value: 'Inlet' },
    { key: 'outlet', value: 'Outlet' },
  ];

  constructor(
    private modelService: ModelService,
    private c3Service: C3Service,
    private apiService: ApiService,
    private authHandler: AuthHandler,
    private cd: ChangeDetectorRef,
    private pointSelectionService: PointSelectionService,
    private boundingBoxService: BoundingBoxService
  ) {}

  ngOnInit(): void {
    const data: BoundaryConType[] = [
      { index: 0, boundary_condition: BoundaryCondition.empty, line_color: { r: 255, g: 0, b: 0 }, data: [] },
      // { index: 1, boundary_condition: BoundaryCondition.empty, line_color: { r: 1, g: 0, b: 0 }, data: [] },
      // { index: 2, boundary_condition: BoundaryCondition.empty, line_color: { r: 0, g: 1, b: 1 }, data: [] },
    ];

    this.dataTableSource = new MatTableDataSource<BoundaryConType>(data);
  }

  public addRow() {
    const data = this.dataTableSource.data;

    const { r, g, b } = ColorTable.getRGBColor(data.length);

    data.push({
      index: data.length,
      boundary_condition: BoundaryCondition.empty,
      line_color: { r: r * 255, g: g * 255, b: b * 255 },
      data: [],
    });
    this.dataTableSource = new MatTableDataSource<BoundaryConType>(data);
    this.activeIndex = data.length - 1;

    this.activate(this.activeIndex);
  }

  public deleteRow(index: number) {
    const data = this.dataTableSource.data;

    const newData = data
      .filter((x) => x.index !== index)
      .map((x, index) => {
        x.index = index;
        return x;
      });

    this.dataTableSource = new MatTableDataSource<BoundaryConType>(newData);
    this.pointSelectionService.redraw(this.viewer, index);
  }

  public changeBoundaryType(type: BoundaryCondition, index: number) {
    const obj = this.dataTableSource.data.filter((x) => x.index === index)[0];
    const new_obj = { ...obj, 'boundary_condition': type };
    this.dataTableSource.data[index] = new_obj;
  }

  public activate(index: number) {
    this.activeIndex = index;
    this.pointSelectionService.setActiveData(this.activeIndex);
  }

  public previewLoadModel(uuid: string) {
    this.loadViewer = true;
    this.cd.detectChanges();

    let width = window.screen.width * 0.35;

    if (screen.width < 1200) {
      width = window.screen.width * 0.7;
    }

    this.c3Service._viewer[this.viewer.toString()].resizeViewer(width, window.screen.height * 0.42);
    this.c3Service._view[this.viewer.toString()].backgroundColor = new Color3(246, 246, 246);

    const access_token = this.authHandler.accessToken || '';

    const sub = this.apiService
      .getMeshingVersionToken(uuid, access_token)
      .pipe(take(1))
      .subscribe((token) => {
        sub.unsubscribe();

        this.modelService.clearTask();
        this.modelService.openModel(token as any, '1');
        this.pointSelectionService.initSelectionListener(this.viewer);
        this.cd.detectChanges();
        console.log('open model !!!');

        //this.modelService.setDrawStyle(this.viewer.toString());
        //console.log('call bounding box service');
        this.boundingBoxService.colorizeParts(this.viewer);

        const viewArray = this.c3Service._view[this.viewer.toString()].getModelArray();
        const model = this.c3Service._model[this.viewer.toString()];
        const partsArray = model.getPartSettingsArray();

        console.log('views:');
        console.log(viewArray);
        console.log('parts:');
        console.log(partsArray);

        setTimeout(() => {
          const modelDirectory = this.c3Service._model[this.viewer.toString()].modelDirectory;
          console.log('modelDirectory');
          console.log(modelDirectory);
        }, 3000);
      });
  }

  drawstyle() {
    const model = this.c3Service._model[this.viewer];
    model.setDrawStyleAllParts(ug.DrawStyle.SURFACE_MESH, 0.3);
    console.log('change draw style');
  }
}
